import {
  LocalStorageService
} from './local-storage.service';
import {
  FilterResource
} from './filter-resource.service';
import {
  Models
} from './model-resource.service';
import {
  Aggregates
} from './aggregate-resource.service';
import {
  TimeUtil
} from './time-util.service';
import {
  loadWithCache
} from './cache.service';
import {
  CurrentFilterService
} from './current-filter.service';
import {
  formatTimeSpan
} from '../common/datetime';
import {
  CancelersService
} from './cancelers.service';
import {
  FilterDataFactory
} from './filter-data.factory';
import {
  CurrentModelService
} from './current-model.service';
import {
  RouterService
} from './router.service';
import {
  FiltersService
} from './filters.service';
import {
  AggregateDataService
} from './aggregate-data.service';
import {
  ErrorHandlerService
} from './error-handler.service';
import {
  PermissionService
} from './permission.service';
import {
  CurrentFilterDataService
} from './current-filter-data.service';
import {
  LayoutService
} from './layout.service';
import {
  FrameLoadService
} from './frame-load.service';
import {
  StatusCheckerService
} from './status-checker.service';
import {
  ServerInformationService
} from './server-information.service';
import {
  AlertModalService
} from './alert-modal/alert-modal.service';
import {
  SpecialModalService
} from './special-modal/special-modal.service';

export const scCoreModule = 'sc-core';

angular.module(scCoreModule, [])
  .service('LocalStorageService', LocalStorageService)
  .filter('gettext', () => gettext)
  .filter('timeSpan', () => formatTimeSpan)
  .service('FilterResource', FilterResource)
  .service('Models', Models)
  .factory('Aggregates', Aggregates)
  .factory('TimeUtil', TimeUtil)
  .factory('loadWithCache', loadWithCache)
  .service('CurrentFilterService', CurrentFilterService)
  .service('CurrentModelService', CurrentModelService)
  .service('CancelersService', CancelersService)
  .factory('FilterDataFactory', FilterDataFactory)
  .service('RouterService', RouterService)
  .service('FiltersService', FiltersService)
  .service('AggregateDataService', AggregateDataService)
  .service('ErrorHandlerService', ErrorHandlerService)
  .service('PermissionService', PermissionService)
  .service('CurrentFilterDataService', CurrentFilterDataService)
  .service('LayoutService', LayoutService)
  .service('FrameLoadService', FrameLoadService)
  .service('StatusCheckerService', StatusCheckerService)
  .service('ServerInformationService', ServerInformationService)
  .service('AlertModalService', AlertModalService)
  .service('SpecialModalService', SpecialModalService);

angular.module(scCoreModule).factory('globalAlert', function($timeout) {
  return function(message, timeout) {
    if (!timeout) timeout = 1000;
    $timeout(() => {
      $('#global-alert').fadeOut(200);
    }, timeout);
    $('#global-alert-message').html(message);
    $('#global-alert').show();
  };
});



// WEBPACK FOOTER //
// ./src/core/core.module.js